module.exports = __webpack_public_path__ + "static/img/381_phase_function_Paper_Points.7af6aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/381_phase_function_Paper_Points.png
// module id = Xfba
// module chunks = 0